import React from 'react';

import consts from './consts.js';

export default function template() {
    if (this.state.hidden) {
        return null;
    }
    return (
        <div
            className="popup"
            role="menuitem"
            aria-label="Dismiss"
            onClick={this.hidePopup.bind(this)}
            tabIndex="0"
            onKeyDown={this.onKeyDown.bind(this)}
        >
            <div
                className="popup-content"
                role="menuitem"
                onClick={this.onContentClick.bind(this)}
                tabIndex="0"
                onKeyDown={this.onKeyDown.bind(this)}
            >
                <p className="text">{this.props.text}</p>
                <button type="button" className="button a11y-unstyled-control" onClick={this.hidePopup.bind(this)}>
                    {consts.LOGIN_BANNER_BUTTON_TEXT}
                </button>
            </div>
        </div>
    );
}
